import T from 'prop-types';
import React from 'react';
import { Column, Grid } from '@acast/decibel';
import DescriptionField from '../fields/description';
import LinkUrlField from '../fields/link-url';
import PositionField from '../fields/position';
import ThumbnailField from '../fields/thumbnail';
import TypeField from '../fields/type';
import { markerPropType } from '../../../../../../customPropTypes';

export default function LinkMarkerSettings({
  episodeDuration,
  errors,
  marker,
  markers,
  onUpdateMarker,
}) {
  return (
    <Grid>
      <Column>
        <ThumbnailField marker={marker} onChange={onUpdateMarker('image')} />
      </Column>
      <Column width="50%">
        <TypeField value={marker.type} onChange={onUpdateMarker('type')} />
      </Column>
      <Column width="50%">
        <PositionField
          marker={marker}
          markers={markers}
          episodeDuration={episodeDuration}
          onChange={onUpdateMarker('start')}
        />
      </Column>
      <Column>
        <LinkUrlField
          error={errors && errors.linkUrl}
          onChange={onUpdateMarker('linkurl')}
          value={marker.body && marker.body.linkurl}
        />
      </Column>
      <Column>
        <DescriptionField value={marker.description} onChange={onUpdateMarker('description')} />
      </Column>
    </Grid>
  );
}

LinkMarkerSettings.propTypes = {
  episodeDuration: T.number,
  errors: T.object,
  marker: markerPropType.isRequired,
  markers: T.arrayOf(markerPropType).isRequired,
  onUpdateMarker: T.func.isRequired,
};
